import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
export default function Stakecards() {
  return (
    <>
      <Tabs>
        <TabList className="staked">
          <Tab>STAKED LITTLE BILLIONAIERS</Tab>
          <Tab>UNSTAKED LITTLE BILLIONAIERS</Tab>
          <button className="custom-btn btn-banner stake_btn side_btn ">
            Stake all
          </button>
        </TabList>
        <TabPanel>
          <div className="container stake_cards">
            <div className="row row_cards">
              <div className="col-sm-3 member-1">
                <div className="card__1">
                  <img src={"images/new/6.3.png"} />
                </div>

                <div className="bottom_card claim_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div>
                  <div className="staking__btn">
                    <span>
                      <button className="unstake-btn">UNSTAKE</button>
                    </span>{" "}
                    <span>
                      <button className="claim-btn">CLAIM</button>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-sm-3 member-2">
                <div className="card__1">
                  <img src={"images/new/6.5.png"} />
                </div>

                <div className="bottom_card claim_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div>
                  <div className="staking__btn">
                    <span>
                      <button className="unstake-btn">UNSTAKE</button>
                    </span>{" "}
                    <span>
                      <button className="claim-btn">CLAIM</button>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-sm-3 member-3">
                <div className="card__1">
                  <img src={"images/new/6.2.png"} />
                </div>

                <div className="bottom_card claim_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div>
                  <div className="staking__btn">
                    <span>
                      <button className="unstake-btn">UNSTAKE</button>
                    </span>{" "}
                    <span>
                      <button className="claim-btn">CLAIM</button>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-sm-3 member-4">
                <div className="card__1">
                  <img src={"images/new/6.2.png"} />
                </div>

                <div className="bottom_card claim_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div>
                  <div className="staking__btn">
                    <span>
                      <button className="unstake-btn">UNSTAKE</button>
                    </span>{" "}
                    <span>
                      <button className="claim-btn">CLAIM</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mate_btn">
            <button className="custom-btn btn-banner stake_btn ban_btn  ">
              CLAIM ALL
            </button>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="container stake_cards">
            <div className="row row_cards">
              <div className="col-sm-3 member-1">
                <div className="card__1">
                  <img src={"images/new/6.3.png"} />
                </div>

                <div className="bottom_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  {/* <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div> */}
                  <div className="staking__btn">
                    <button className="btns">STAKE</button>
                  </div>
                </div>
              </div>

              <div className="col-sm-3 member-2">
                <div className="card__1">
                  <img src={"images/new/6.5.png"} />
                </div>

                <div className="bottom_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  {/* <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div> */}
                  <div className="staking__btn">
                    <button className="btns">STAKE</button>
                  </div>
                </div>
              </div>

              <div className="col-sm-3 member-3">
                <div className="card__1">
                  <img src={"images/new/6.2.png"} />
                </div>

                <div className="bottom_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  {/* <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div> */}
                  <div className="staking__btn">
                    <button className="btns">STAKE</button>
                  </div>
                </div>
              </div>

              <div className="col-sm-3 member-4">
                <div className="card__1">
                  <img src={"images/new/6.2.png"} />
                </div>

                <div className="bottom_card">
                  <div className="card_name">
                    <h4>Little Billionaires #1520</h4>
                  </div>
                  {/* <div className="earner_card">
                    <p>Total $LITTLE earned: 690</p>
                  </div> */}
                  <div className="staking__btn">
                    <button className="btns">STAKE</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mate_btn">
            <button className="custom-btn btn-banner stake_btn ban_btn ">
              Stake all
            </button>
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
}
